import styled from 'styled-components';
import { renderStyledElementStyles } from '../../../../helpers';

export const SubTitle = styled.h3`
  ${({ theme }) =>
    renderStyledElementStyles(theme, theme.module.vStyles.elements.subTitle)}
  ${({ theme }) =>
    renderStyledElementStyles(theme, theme.module.dStyles.elements.subTitle)}
`;
